import(/* webpackMode: "eager", webpackExports: ["SliderView"] */ "/home/runner/work/apps/apps/packages/user-web-app/app/[companySlug]/[storySlug]/view/SliderView.tsx");
